module.exports = __webpack_public_path__ + "img/DealerIcons-LinkedIn-Off.61b2f1b.jpg";